import React, { useState, useEffect, lazy, Suspense } from 'react'
import './App.css';
import 'swiper/css';
// dependencies
import { Route, Routes, useLocation } from 'react-router-dom'
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { AnimatePresence } from 'framer-motion'
import DeferredChat from './components/DeferredChat';
// components (always in the initial bundle: shell + popup)
import Header from './components/Header';
import Cursor from './components/Cursor';
import Footer from './components/Footer';
import Popup from './components/Popup';
import { trackPageView } from './api/client';
// pages (lazy-loaded so each route ships as its own chunk)
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Thankyou = lazy(() => import('./pages/Thankyou'));
const Work = lazy(() => import('./pages/Work'));
const Contact = lazy(() => import('./pages/Contact'));
const Services = lazy(() => import('./pages/Services'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Pricing = lazy(() => import('./pages/Pricing'));
const CustomWebsite = lazy(() => import('./pages/CustomWebsite'));
const WordpressDevelopment = lazy(() => import('./pages/WordpressDevelopment'));
const ShopifyWebsite = lazy(() => import('./pages/ShopifyWebsite'));
const EcommerceSolutions = lazy(() => import('./pages/EcommerceSolutions'));
const MobileAppSolutions = lazy(() => import('./pages/MobileAppSolutions'));
const LogoDesign = lazy(() => import('./pages/LogoDesign'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const NotFound = lazy(() => import('./pages/NotFound'));

const App = () => {
  const [isTouchable, setIsTouchable] = useState(false);
  const location = useLocation()
  useEffect(() => {
    setIsTouchable('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
  }, [])
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);
  // Record a page view on every route change (fire-and-forget; no-op without API).
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return (
    <>
      {!isTouchable ? <Cursor /> : <></>}
      <Header />
      <main>
        <Suspense fallback={<div className="route-loader" style={{ minHeight: '60vh' }} />}>
          <AnimatePresence mode='wait'>
            <Routes location={location} key={location.pathname} >
              <Route path='/' element={<Home />} />
              <Route path='/about' element={<About />} />
              <Route path='/work' element={<Work />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/services' element={<Services />} />
              <Route path='/faq' element={<FAQ />} />
              <Route path='/pricing' element={<Pricing />} />
              <Route path='/custom-website' element={<CustomWebsite />} />
              <Route path='/wordpress-development' element={<WordpressDevelopment />} />
              <Route path='/shopify-website' element={<ShopifyWebsite />} />
              <Route path='/ecommerce-solutions' element={<EcommerceSolutions />} />
              <Route path='/mobile-app-solutions' element={<MobileAppSolutions />} />
              <Route path='/logo-design' element={<LogoDesign />} />
              <Route path='/terms-conditions' element={<TermsConditions />} />
              <Route path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route path='/thankyou' element={<Thankyou />} />
              <Route path='*' element={<NotFound />} />
            </Routes>
          </AnimatePresence>
        </Suspense>
      </main>
      <Popup />
      {/* https://embed.tawk.to/69fa3b01aaf1051c36970dbc/1jnsnd0a9'; */}
      <DeferredChat
        propertyId="69fa3b01aaf1051c36970dbc"
        widgetId="1jnsnd0a9"
      />
      <Footer />
    </>
  )
}

export default App
